// ============================================================
// DEMOISELLE ATYPIQUE — FICHIER DE CONTENU CENTRALISÉ
// Textes, équipe, offres, réalisations, chiffres clés,
// témoignages et webinaire se modifient ICI.
// Univers de marque : aubergine profond, néon rose, or chaud.
// Toutes les photos de logements proviennent de nos webinaires
// (nos réalisations et celles de nos clients).
// ============================================================

export const BRAND = {
  name: "Demoiselle Atypique",
  baseline: "Investissement immobilier atypique & accompagnement.",
  instagram: "https://www.instagram.com/demoiselle_atypique/",
  motto: ["Immobilier", "Liberté", "Audace", "Plaisir"],
};

export const SEO = {
  title: "Demoiselle Atypique | Investissement immobilier atypique, suites romantiques & hébergements à thème",
  description:
    "Demoiselle Atypique accompagne les investisseurs pour créer un hébergement atypique rentable : suite romantique, logement familial à thème, univers gaming ou cinéma, refuge nature, lieu de séminaire. Méthode structurée, équipe dédiée, accompagnement sur mesure.",
};

export const NAV_LINKS = [
  { label: "Méthode", to: "/#methode" },
  { label: "Formation", to: "/formation" },
  { label: "Accompagnements", to: "/#accompagnements" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Études de cas", to: "/realisations#etudes-de-cas" },
  { label: "À propos", to: "/a-propos" },
  { label: "Avis", to: "/avis" },
];

export const IMAGES = {
  hero: "/brand/hero.jpg",
  neonWall: "/brand/neon-wall.jpg",
  webinarVisual: "/brand/logo.jpg",
  positionnement: "/univers/positionnement.jpg",
  differenciation: "/realisations/pomme-netflix.jpg",
  apropos1: "/univers/apropos-1.jpg",
  apropos2: "/univers/apropos-2.jpg",
  apropos3: "/univers/apropos-3.jpg",
  avantApres: {
    avant: "/realisations/eclipse-avant-salon.jpg",
    apres: "/realisations/eclipse-apres-salon.jpg",
  },
};

// ---------- BANDEAU DÉFILANT (mots de la marque) ----------
export const MARQUEE_ITEMS = ["Rêve", "Investis", "Crée", "Ta liberté", "Immobilier", "Audace", "Plaisir"];

// ---------- NOTRE MÉTHODE (01 → 09) ----------
export const METHOD_STEPS = [
  { number: "01", title: "Stratégie", description: "Définition du projet, objectifs et stratégie d'investissement." },
  { number: "02", title: "Recherche", description: "Recherche du bien et analyse de son potentiel." },
  { number: "03", title: "Rentabilité", description: "Étude du marché, prévisionnel et analyse financière." },
  { number: "04", title: "Financement", description: "Préparation et structuration du projet." },
  { number: "05", title: "Concept", description: "Création d'une expérience et d'un positionnement différenciant." },
  { number: "06", title: "Travaux & aménagement", description: "Organisation, chiffrage, architecture, décoration et optimisation des espaces." },
  { number: "07", title: "Commercialisation", description: "Création des annonces, photos, plateformes et stratégie tarifaire." },
  { number: "08", title: "Lancement", description: "Mise en ligne et premières réservations." },
  { number: "09", title: "Optimisation", description: "Analyse des performances et amélioration continue de la rentabilité." },
];

// ---------- ÉQUIPE ----------
export const TEAM = [
  { id: "elise", prenom: "Élise", role: "Fondatrice — Stratégie & investissement", description: "Vision du projet, stratégie, recherche et accompagnement. Elle a transformé son garage en premier logement atypique en 2021.", photo: "/equipe/elise.jpg" },
  { id: "laurent", prenom: "Laurent", role: "Technique & chiffrage", description: "Analyse technique des biens, travaux et maîtrise des coûts. 20 ans dans le bâtiment.", photo: null },
  { id: "laurie", prenom: "Laurie", role: "Architecture & décoration", description: "Conception des espaces, décoration et création d'expériences différenciantes.", photo: null },
  { id: "anais", prenom: "Anaïs", role: "Gestion & communication", description: "Organisation, exploitation et communication.", photo: null },
  { id: "jeremy", prenom: "Jérémy Négrier", role: "Investisseur immobilier", description: "Dans l'immobilier depuis ses 20 ans, il a exploré et testé de nombreuses stratégies avant de se consacrer aux logements atypiques.", photo: null },
];

// ---------- LA FONDATRICE (section de présentation d'Élise) ----------
// Remplacez simplement `photo` par le chemin de la photo définitive.
export const FOUNDER = {
  eyebrow: "La fondatrice",
  title: "Élise, passionnée d'immobilier atypique et d'expériences qui sortent de l'ordinaire",
  photo: "/equipe/elise-portrait.jpg",
  photoAlt: "Élise, fondatrice de Demoiselle Atypique, à son bureau devant le logo de la marque",
  // Les segments entre ** ** sont mis en valeur.
  paragraphs: [
    "J'ai toujours aimé voir dans un bien immobilier **ce que les autres ne voient pas encore**.",
    "Un espace à transformer, un concept à imaginer, une expérience à créer… Pour moi, un investissement immobilier ne doit pas seulement être rentable : il doit avoir **une identité** et une vraie raison d'être choisi.",
    "Après avoir créé et exploité nos propres hébergements atypiques, j'ai fondé Demoiselle Atypique avec l'envie de transmettre **une méthode issue de notre propre expérience terrain**.",
    "Aujourd'hui, avec mon équipe, j'accompagne des investisseurs dans toutes les étapes de leur projet : stratégie, recherche du bien, analyse de rentabilité, financement, concept, travaux, décoration, commercialisation et optimisation.",
    "Notre spécialité : **identifier le potentiel d'un bien** et imaginer comment le transformer en un projet **différenciant, désirable et rentable**.",
    "Love Rooms, suites romantiques, hébergements atypiques ou autres concepts immobiliers : nous ne cherchons pas à reproduire ce qui existe déjà. **Nous cherchons ce qui fera la différence.**",
  ],
  quote: "Je ne veux pas simplement vous aider à acheter un bien. Je veux vous aider à créer un projet qui se démarque et qui performe.",
  blocks: [
    { icon: "Building2", label: "Immobilier", value: "Investisseuse & entrepreneure" },
    { icon: "HardHat", label: "Terrain", value: "Des projets créés et exploités" },
    { icon: "Route", label: "Accompagnement", value: "De l'idée au lancement" },
    { icon: "Sparkles", label: "Atypique", value: "Notre spécialité" },
  ],
  cta: "Parler de mon projet",
};

// ---------- LES UNIVERS (présentés dans le webinaire) ----------
export const UNIVERSES = [
  { id: "destination", kicker: "Destination", name: "Santorin", description: "Suite romantique inspirée des Cyclades. Idée de thème : une destination avec une vraie identité à reproduire.", image: "/univers/univers-destination.jpg", alt: "Suite Santorini — spa, sauna et décor des Cyclades, projet d'un client accompagné" },
  { id: "gaming", kicker: "Gaming", name: "Logement familial jeux vidéo", description: "Un hébergement familial inspiré des jeux vidéo : tunnels, briques et écrans pour jouer en famille.", image: "/univers/univers-gaming.jpg", alt: "Logement familial atypique inspiré des jeux vidéo — décor Mario, toboggan et espace de jeu" },
  { id: "familial", kicker: "Familial", name: "Univers féerique", description: "Logement familial immersif inspiré des contes : le projet de Tiffany, accompagnée par notre équipe.", image: "/univers/univers-familial.jpg", alt: "Chambre familiale féerique avec fresque de château et montgolfières" },
  { id: "cinema", kicker: "Films & séries cultes", name: "Sorciers, séries & films", description: "S'inspirer d'un film ou d'une série culte : Friends, Stranger Things, Retour vers le futur, Maman j'ai raté l'avion, Avatar...", image: "/univers/univers-cinema.jpg", alt: "Salon inspiré de l'univers Harry Potter — briques, bougies et écharpes de sorciers" },
  { id: "romantique", kicker: "Suite romantique", name: "Black Room", description: "La suite d'exception de Charles à Douai : spa, sauna et néon violet. Devenue L'Éclipse.", image: "/realisations/eclipse.jpg", alt: "Black Room devenue L'Éclipse — suite romantique sombre avec spa et néons violets" },
  { id: "nature", kicker: "Nature", name: "Refuge déconnecté", description: "Suite romantique au cœur de la nature. Concept déconnecté, sans téléphone.", image: "/univers/univers-nature.jpg", alt: "Suite romantique nature avec bain rond et matériaux bruts — concept déconnecté" },
  { id: "workfun", kicker: "Work & Fun", name: "Séminaires d'entreprise", description: "Logement à destination des séminaires d'entreprise : concept travail et fun, billard, grandes tablées.", image: "/univers/univers-workfun.jpg", alt: "Loft work & fun pour séminaires d'entreprise — billard, néons et espaces de travail" },
];

// ---------- ACCOMPAGNEMENTS (aucun tarif affiché) ----------
export const OFFERS = [
  {
    id: "formation",
    index: "01",
    name: "Formation",
    description:
      "Une formation destinée aux personnes souhaitant comprendre notre méthode et apprendre à construire un projet immobilier atypique, différenciant et rentable.",
    details: [],
    cta: "DÉCOUVRIR LA FORMATION",
    to: "/formation",
    featured: false,
  },
  {
    id: "accompagnement-personnalise",
    index: "02",
    name: "Accompagnement personnalisé",
    description:
      "Pour les investisseurs souhaitant ne plus avancer seuls et bénéficier de l'expertise de notre équipe dans les différentes étapes de leur projet.",
    details: ["Stratégie", "Recherche", "Analyse", "Rentabilité", "Financement", "Concept", "Travaux", "Décoration", "Commercialisation", "Exploitation"],
    cta: "PARLER DE MON PROJET",
    to: "/rendez-vous",
    featured: true,
  },
  {
    id: "accompagnement-premium",
    index: "03",
    name: "Accompagnement premium",
    description:
      "Un accompagnement sur mesure destiné aux investisseurs souhaitant être suivis dans la durée, de la réflexion initiale jusqu'au lancement et à l'optimisation de leur activité.",
    details: [],
    cta: "CANDIDATER",
    to: "/rendez-vous",
    featured: false,
  },
];

// ---------- RÉALISATIONS ----------
// Vrais projets (nos logements + ceux de nos clients), présentés dans nos
// webinaires. rating = note voyageurs réelle ; figures & témoignages réels.
export const REALISATION_CATEGORIES = [
  { id: "tous", label: "Tous les projets" },
  { id: "love-rooms", label: "Suites romantiques & Love Rooms" },
  { id: "immersif", label: "Hébergements immersifs & familiaux" },
];

export const PROJECTS = [
  {
    id: "la-caliente",
    name: "La Caliente",
    category: "love-rooms",
    location: "Gujan-Mestras",
    type: "Love Room",
    rating: "4,88",
    concept: "Spa privé et pièce secrète dans une ambiance tropicale, pensée pour les séjours en amoureux.",
    cover: "/realisations/la-caliente.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "7eme-ciel",
    name: "7ème Ciel",
    category: "love-rooms",
    location: "Sainte-Bazeille",
    type: "Suite d'exception",
    rating: null,
    concept: "Suite d'exception avec spa privatif, mosaïque dorée et ambiance feutrée.",
    cover: "/realisations/7eme-ciel.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "la-cachette",
    name: "La Cachette",
    category: "love-rooms",
    location: "Audenge",
    type: "Love Room",
    rating: null,
    concept: "Le deuxième bien d'Élise : un cocon secret, intime et enveloppant, avec bain privatif au cœur de la végétation.",
    cover: "/realisations/la-cachette.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "la-serenita",
    name: "La Sérénita",
    category: "love-rooms",
    location: "Ludon-Médoc",
    type: "Suite privée de luxe",
    rating: null,
    concept: "Suite privée de luxe avec spa extérieur et terrasse en bois ouverte sur la vue.",
    cover: "/realisations/la-serenita.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "tropic-art",
    name: "La Suite Tropic'Art",
    category: "love-rooms",
    location: "Lamballe",
    type: "Love Room",
    rating: null,
    concept: "Suite artistique au décor street art tropical, avec jacuzzi privatif.",
    cover: "/realisations/tropic-art.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "canopea",
    name: "Canopea",
    category: "love-rooms",
    location: "Nailloux",
    type: "Love Room",
    rating: null,
    concept: "Refuge boisé et végétal avec spa privatif et lumière tamisée.",
    cover: "/realisations/canopea.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "santorini",
    name: "Suite Santorini",
    category: "love-rooms",
    location: "Pézenas",
    type: "Suite privée de luxe",
    rating: "4,98",
    concept: "Suite inspirée des Cyclades : lit rond, sauna et spa privatif. Le projet de Romain, accompagné par notre équipe.",
    caseStudy: "/etude-de-cas/santorin",
    cover: "/realisations/santorini.jpg",
    gallery: ["/realisations/santorin-r1.jpg", "/realisations/santorin-r2.jpg", "/realisations/santorin-r3.jpg", "/realisations/g-santorini.jpg", { src: "/realisations/santorin-avant.jpg", tag: "Avant travaux" }],
    beforeAfter: null,
    figures: [
      { label: "Prix total du projet", value: "161 000 €" },
      { label: "Travaux & aménagement", value: "45 000 €" },
      { label: "Financement obtenu", value: "110 %" },
    ],
    testimonial: null,
  },
  {
    id: "charmeuse",
    name: "La Charmeuse",
    category: "love-rooms",
    location: "Belin-Béliet",
    type: "Suite privée de luxe",
    rating: "4,84",
    concept: "Suite privée de luxe avec cheminée, pétales et ambiance feutrée — le premier bien transformé par Élise.",
    cover: "/realisations/charmeuse.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [{ label: "Revenus locatifs", value: "2 872 €/mois" }],
    testimonial: null,
  },
  {
    id: "eclipse",
    name: "L'Éclipse",
    category: "love-rooms",
    location: "Douai",
    type: "Suite d'exception",
    rating: "5,0",
    concept: "Née d'un bien à Douai transformé en suite d'exception sombre et sensuelle : spa, sauna et ambiance néon violette. Le projet de Charles, suivi par notre équipe.",
    caseStudy: "/etude-de-cas/eclipse",
    cover: "/realisations/eclipse.jpg",
    gallery: ["/realisations/eclipse-1.jpg", "/realisations/eclipse-2.jpg", "/realisations/g-eclipse.jpg", { src: "/realisations/eclipse-avant-salon.jpg", tag: "Avant travaux" }, { src: "/realisations/eclipse-apres-salon.jpg", tag: "Après travaux" }, { src: "/realisations/eclipse-avant.jpg", tag: "Avant travaux" }, { src: "/realisations/eclipse-avant-2.jpg", tag: "Avant travaux" }, { src: "/realisations/eclipse-chantier.jpg", tag: "Pendant les travaux" }],
    beforeAfter: null,
    figures: [
      { label: "Cash-flow net", value: "+ 2 600 €/mois" },
      { label: "Nuits louées", value: "25 / mois" },
      { label: "Taux d'occupation", value: "80 %" },
      { label: "Prix moyen par nuit", value: "280 €" },
    ],
    testimonial: {
      texte: "Sans l'accompagnement, je n'aurais jamais acheté cet appartement. Élise est incroyable, toujours disponible, toujours là pour motiver quand les doutes s'installent.",
      auteur: "Charles — propriétaire de L'Éclipse, Douai",
    },
  },
  {
    id: "bahalove",
    name: "Bahalove",
    category: "love-rooms",
    location: "Montréjeau",
    type: "Suite privée de charme",
    rating: "4,91",
    concept: "Suite privée de charme avec balnéo privative, pétales et néons féeriques.",
    cover: "/realisations/bahalove.jpg",
    gallery: ["/realisations/g-bahalove.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "secret-du-nil",
    name: "Le Secret du Nil",
    category: "love-rooms",
    location: "Le Gué-de-Velluire",
    type: "Love Room & Spa",
    rating: "4,92",
    concept: "Spa & détente dans un écrin doré inspiré de l'Égypte ancienne.",
    cover: "/realisations/secret-du-nil.jpg",
    gallery: ["/realisations/g-nil.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "oasis-cubana",
    name: "OasisCubana",
    category: "love-rooms",
    location: "Belley",
    type: "Love Room",
    rating: "4,96",
    concept: "Love room tropicale avec grande balnéo privative et palmiers en fresque.",
    cover: "/realisations/oasis-cubana.jpg",
    gallery: ["/realisations/g-oasis.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "miami-secret",
    name: "Miami Secret",
    category: "love-rooms",
    location: "Valentigney",
    type: "Love Room",
    rating: "5,0",
    concept: "Univers Miami : balnéo privative et décoration tropicale lumineuse.",
    cover: "/realisations/miami-secret.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "love-room-balneo",
    name: "Love Room Balnéo Privée",
    category: "love-rooms",
    location: "Serris",
    type: "Love Room",
    rating: "4,88",
    concept: "Love room avec balnéo privée, aux portes de Disneyland Paris.",
    cover: "/realisations/love-room-balneo.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "enchantee",
    name: "L'Enchantée",
    category: "immersif",
    location: "Crécy-la-Chapelle",
    type: "Appartement familial",
    rating: "4,81",
    concept: "Appartement immersif pour 6 personnes, à 15 minutes de Disneyland Paris.",
    cover: "/realisations/enchantee.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "pimenta",
    name: "La Pimenta",
    category: "love-rooms",
    location: "Dole",
    type: "Love Room",
    rating: "4,97",
    concept: "Escapade romantique : balnéo privée et mur végétal sous néons.",
    cover: "/realisations/pimenta.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "pomme-d-amour",
    name: "La Pomme d'Amour",
    category: "love-rooms",
    location: "Walscheid",
    type: "Suite prestige",
    rating: "4,97",
    concept: "Suite prestige inspirée de la fête foraine et du cinéma : rayures rouge et blanc, écran de projection, pop-corn et pomme d'amour géante.",
    cover: "/realisations/pomme-d-amour.jpg",
    gallery: ["/realisations/pomme-netflix.jpg", "/realisations/pomme-chambre.jpg", "/realisations/pomme-popcorn.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "sensuelle",
    name: "La Sensuelle",
    category: "love-rooms",
    location: "Vendres",
    type: "Suite romantique",
    rating: "4,84",
    concept: "Suite romantique et sensuelle, balnéo privative dans un écrin de pierre.",
    cover: "/realisations/sensuelle.jpg",
    gallery: ["/realisations/g-sensuelle.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "ecrin-du-desir",
    name: "L'Écrin du Désir",
    category: "love-rooms",
    location: "Capestang",
    type: "Love Room",
    rating: "4,96",
    concept: "Love room au décor bleu nuit avec balnéo lumineuse.",
    cover: "/realisations/ecrin-du-desir.jpg",
    gallery: ["/realisations/g-ecrin.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "parenthese",
    name: "La Parenthèse",
    category: "love-rooms",
    location: "Boutigny-sur-Opton",
    type: "Suite privée",
    rating: "4,95",
    concept: "Une parenthèse hors du temps : bain nordique extérieur en bois.",
    cover: "/realisations/parenthese.jpg",
    gallery: ["/realisations/g-parenthese.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "californie-cannes",
    name: "La Californie de Cannes",
    category: "love-rooms",
    location: "Cannes",
    type: "Suite de luxe",
    rating: "4,92",
    concept: "Suite de luxe avec balnéo et vue, dans un écrin doré.",
    cover: "/realisations/californie-cannes.jpg",
    gallery: ["/realisations/g-cannes.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "hakuna-lodge",
    name: "Hakuna Lodge",
    category: "love-rooms",
    location: "Serris",
    type: "Suite romantique",
    rating: "4,9",
    concept: "Univers savane et nature : bois brut, végétation, fresque lion, lit sur estrade lumineuse et spa privatif.",
    cover: "/realisations/hakuna-lodge.jpg",
    gallery: [],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
  {
    id: "utopia",
    name: "L'Utopia",
    category: "immersif",
    location: "Quincy-Voisins",
    type: "Airbnb immersif familial",
    rating: "4,8",
    concept: "Airbnb immersif inspiré des films d'animation cultes : chambre Toy Story, cuisine façon Ratatouille, chambres colorées pour toute la famille.",
    cover: "/realisations/utopia-toystory.jpg",
    gallery: ["/realisations/utopia-cuisine.jpg", "/realisations/utopia.jpg", "/realisations/utopia-chambre-1.jpg", "/realisations/utopia-chambre-2.jpg"],
    beforeAfter: null,
    figures: [],
    testimonial: null,
  },
];

// ---------- ÉTUDES DE CAS (chiffres présentés dans le webinaire) ----------
export const CASE_STUDIES = {
  eclipse: {
  slug: "eclipse",
  path: "/etude-de-cas/eclipse",
  eyebrow: "Étude de cas n°1",
  seoTitle: "Étude de cas — L'Éclipse à Douai : + 2 600 € de cash-flow net par mois | Demoiselle Atypique",
  seoDescription: "Prix d'achat, travaux, financement, revenus et cash-flow : tous les chiffres réels de la Black Room de Charles, devenue L'Éclipse, suite privée de luxe à Douai accompagnée par Demoiselle Atypique.",
  title: "La Black Room de Charles, devenue L'Éclipse.",
  intro:
    "Un appartement de 80 000 € à Douai, un propriétaire en CDD qui n'avait jamais investi, et un accompagnement de A à Z. Voici, chiffre par chiffre, comment ce bien génère aujourd'hui + 2 600 € nets par mois.",
  cover: "/realisations/eclipse-r2.jpg",
  coverAlt: "L'Éclipse à Douai — enseigne lunaire, canapé et néons violets de la suite privée de luxe",
  beforeAfter: { avant: "/realisations/eclipse-avant-salon.jpg", apres: "/realisations/eclipse-apres-salon.jpg", altAvant: "Appartement vide de Charles à Douai avant travaux", altApres: "L'Éclipse après transformation — suite privée de luxe" },
  kpis: [
    { value: "+ 2 600 €", label: "Cash-flow net / mois" },
    { value: "80 %", label: "Taux d'occupation" },
    { value: "280 €", label: "Prix moyen / nuit" },
    { value: "25", label: "Nuits louées / mois" },
  ],
  profileTitle: "Un premier investissement, en CDD, en nom propre.",
  profile: [
    { label: "Prénom", value: "Charles" },
    { label: "Ville", value: "Douai (59)" },
    { label: "Statut", value: "CDD" },
    { label: "Structure", value: "Nom propre" },
    { label: "Type de projet", value: "Logement atypique" },
  ],
  projectTitle: "Achat, travaux et financement : tout est chiffré.",
  project: [
    { label: "Prix affiché", value: "80 000 €" },
    { label: "Négociation", value: "− 2 000 €" },
    { label: "Prix d'achat (FAI)", value: "78 000 €" },
    { label: "Frais de notaire", value: "7 000 €" },
    { label: "Travaux + aménagement", value: "57 800 €" },
    { label: "Financement total", value: "~ 158 000 €", strong: true },
    { label: "Apport personnel", value: "14 200 €" },
    { label: "Crédit", value: "158 000 € · nom propre" },
    { label: "Mensualité pendant le différé", value: "400 € (2 ans)" },
    { label: "Mensualité pleine", value: "750 € (nov. 2026)" },
  ],
  performanceTitle: "Ce que le bien rapporte, chaque mois, une fois tout payé.",
  performanceLabel: "Performances mensuelles moyennes",
  performance: [
    { label: "Nuits louées", value: "25 / mois" },
    { label: "Taux d'occupation", value: "80 %" },
    { label: "Revenus locatifs", value: "4 700 €" },
    { label: "Extras (options)", value: "+ 350 €" },
    { label: "Charges totales", value: "~ 1 500 €" },
    { label: "Cash-flow net", value: "+ 2 600 €", strong: true },
  ],
  performanceNote: "Performances mensuelles moyennes. Mensualité pendant le différé : 400 € → mensualité pleine (nov. 2026) : 750 €.",
  steps: [
    { tag: "Avant", title: "Un appartement blanc, vide et sans identité", text: "Salle de bain d'origine, cuisine d'origine, murs blancs et parquet stratifié : rien ne le distinguait des dizaines d'annonces voisines.", images: ["/realisations/eclipse-avant-salon.jpg", "/realisations/eclipse-avant.jpg", "/realisations/eclipse-avant-2.jpg"] },
    { tag: "Pendant", title: "57 800 € de travaux et d'aménagement, pilotés", text: "Plafond noir, tasseaux, éclairage, sauna, spa : le chantier est planifié, chiffré et suivi pour respecter le budget et le concept jusqu'au bout.", images: ["/realisations/eclipse-chantier.jpg", "/realisations/eclipse-chantier-2.jpg"] },
    { tag: "Après", title: "L'Éclipse — une suite privée de luxe notée 5,0", text: "Lit rond, sauna infrarouge, spa, écran de projection et enseigne lunaire : une expérience qu'on ne trouve nulle part ailleurs à Douai.", images: ["/realisations/eclipse-r1.jpg", "/realisations/eclipse-r3.jpg", "/realisations/eclipse-r4.jpg", "/realisations/eclipse-r5.jpg"] },
  ],
  testimonial: {
    texte: "Sans l'accompagnement, je n'aurais jamais acheté cet appartement. Élise est incroyable, toujours disponible, toujours là pour motiver quand les doutes s'installent.",
    auteur: "Charles — propriétaire de L'Éclipse, Douai",
    photo: "/clients/charles.jpg",
  },
  reviews: [],
  closing: { text: "Charles n'avait jamais investi.", em: "Et vous, quel est votre bien ?" },
  disclaimer: "Chiffres communiqués par le propriétaire et présentés lors de notre webinaire. Chaque projet est unique : les performances passées ne constituent pas une garantie de résultat.",
  other: { label: "Étude de cas suivante : la suite Santorin", to: "/etude-de-cas/santorin" },
  },
  santorin: {
  slug: "santorin",
  path: "/etude-de-cas/santorin",
  eyebrow: "Étude de cas n°2",
  seoTitle: "Étude de cas — La suite Santorin à Pézenas : 161 000 € financés à 110 % | Demoiselle Atypique",
  seoDescription: "Prix négocié, notaire, travaux, financement à 110 %, revenus et bénéfice mensuel : les chiffres réels de la suite Santorin de Romain à Pézenas, accompagnée par Demoiselle Atypique.",
  title: "La suite Santorin de Romain, à Pézenas.",
  intro:
    "Une ruine à 118 000 € affichés dans une ville de 7 500 habitants, financée à 110 % avec deux ans de différé. Quelques mois après l'ouverture, la suite est « Coup de cœur voyageurs » et sa marge progresse chaque mois.",
  cover: "/realisations/santorin-r1.jpg",
  coverAlt: "Suite Santorin à Pézenas — bain rond, sauna, bougainvilliers et volets bleus des Cyclades",
  beforeAfter: { avant: "/realisations/santorin-avant.jpg", apres: "/realisations/santorin-r1.jpg", altAvant: "Le bien de Romain à Pézenas avant travaux — gravats et murs à nu", altApres: "La suite Santorin après transformation — bain rond et décor des Cyclades" },
  kpis: [
    { value: "110 %", label: "Financement obtenu" },
    { value: "+ 1 940 €", label: "Bénéfice mensuel (mai 2026)" },
    { value: "4,98", label: "Note voyageurs · Coup de cœur" },
    { value: "51 %", label: "Marge bénéficiaire (mai 2026)" },
  ],
  profileTitle: "Un client accompagné de la recherche au lancement.",
  profile: [
    { label: "Prénom", value: "Romain" },
    { label: "Ville", value: "Pézenas (34)" },
    { label: "Population", value: "~ 7 500 hab." },
    { label: "Statut Airbnb", value: "Superhôte" },
    { label: "Type de projet", value: "Suite romantique" },
  ],
  projectTitle: "Négociation, travaux et financement à 110 %.",
  project: [
    { label: "Prix affiché", value: "118 000 €" },
    { label: "Prix négocié (frais d'agence 8 500 € inclus)", value: "104 000 €" },
    { label: "Frais de notaire", value: "8 200 €" },
    { label: "Travaux", value: "45 000 €" },
    { label: "Total du projet", value: "161 000 €", strong: true },
    { label: "Financement", value: "110 %" },
    { label: "Différé partiel", value: "2 ans" },
    { label: "Mensualité pendant le différé", value: "457 € / mois" },
    { label: "Mensualité pleine", value: "850 € / mois" },
  ],
  performanceTitle: "Des chiffres qui progressent dès les premiers mois.",
  performanceLabel: "Aperçu mensuel — outil de gestion du propriétaire",
  performanceColumns: ["Fév. 2026 · lancement", "Mai 2026"],
  performance: [
    { label: "Revenus nets", values: ["3 064 €", "3 793 €"] },
    { label: "Charges nettes", values: ["1 678 €", "1 853 €"] },
    { label: "Bénéfice (avant impôts)", values: ["+ 1 386 €", "+ 1 940 €"], strong: true },
    { label: "Marge bénéficiaire", values: ["45 %", "51 %"] },
  ],
  performanceNote: "Chiffres issus de l'outil de gestion de Romain : premier mois d'exploitation (février 2026) puis mai 2026. Mensualité de 457 € pendant le différé, 850 € ensuite.",
  steps: [
    { tag: "Avant", title: "Une ruine que personne ne voulait", text: "Plafonds effondrés, gravats, murs à nu : un bien affiché 118 000 € et négocié 104 000 € frais d'agence inclus.", images: ["/realisations/santorin-avant.jpg"] },
    { tag: "Après", title: "Un morceau des Cyclades dans l'Hérault", text: "Bain rond, sauna, bougainvilliers, volets bleus et douche à l'italienne façon Santorin : 45 000 € de travaux pour une identité impossible à comparer.", images: ["/realisations/santorin-r1.jpg", "/realisations/santorin-r2.jpg", "/realisations/santorin-r3.jpg", "/realisations/g-santorini.jpg"] },
  ],
  testimonial: null,
  reviews: [
    { image: "/clients/avis-santorin-hote.jpg", alt: "Suite Santorin — Coup de cœur voyageurs, 4,98 sur 5, hôte Romain Superhôte" },
    { image: "/clients/avis-santorin-1.jpg", alt: "Avis de Khaled : une expérience absolument magnifique, transportés directement à Santorin" },
    { image: "/clients/avis-santorin-2.jpg", alt: "Avis de Joyti et Nicolas : suite sensationnelle, ambiance élégante et dépaysante" },
  ],
  closing: { text: "Une petite ville. Une ruine. Un financement à 110 %.", em: "Et si c'était votre prochain projet ?" },
  disclaimer: "Chiffres communiqués par le propriétaire et présentés lors de notre webinaire. Chaque projet est unique : les performances passées ne constituent pas une garantie de résultat.",
  other: { label: "Étude de cas précédente : L'Éclipse", to: "/etude-de-cas/eclipse" },
  },
};

// ---------- SIMULATEUR & RÈGLE DES 6 NUITS ----------
export const SIMULATOR = {
  eyebrow: "La règle des 6 nuits",
  title: "6 nuits louées = ton crédit et tes charges remboursés. À partir de la 7e, c'est du cash-flow net.",
  text: "C'est la règle simple que nous appliquons sur chaque projet atypique. Renseigne ton projet pour estimer ta mensualité, le nombre de nuits nécessaires pour tout couvrir, et ce qu'il te reste dans la poche chaque mois.",
  defaults: { prix: 100000, travaux: 40000, apport: 10000, taux: 3.5, duree: 20, prixNuit: 220, nuits: 18, charges: 800 },
  notaireRate: 0.08,
  disclaimer: "Estimation indicative, hors assurance emprunteur et fiscalité. Ne constitue pas un conseil financier : chaque projet est étudié en détail lors de notre premier rendez-vous.",
  cta: "Valider mon projet avec l'équipe",
};

// ---------- CHIFFRES CLÉS ----------
// Valeurs réelles uniquement (issues du webinaire & des annonces publiques).
// "value: null" affiche un emplacement "À venir".
export const FIGURES = [
  { label: "Personnes accompagnées", value: "Des centaines" },
  { label: "Cash-flow mensuel de nos clients", value: "1 000 à 2 500 €" },
  { label: "Revenus du premier projet d'Élise", value: "3 240 €/mois" },
  { label: "Revenus mensuels de La Charmeuse", value: "2 872 €/mois" },
  { label: "Années d'expérience", value: "Depuis 2021" },
];

// ---------- TÉMOIGNAGES ----------
// Vrais témoignages uniquement. Pour ajouter un témoignage, copiez un bloc :
// { prenom: "Prénom", projet: "Type de projet — Ville", texte: "…", resultat: null, photo: "/clients/prenom.jpg", video: null, link: null }
// (photo, resultat, video et link sont optionnels : mettez null pour ne rien afficher.)
export const TESTIMONIALS = [
  {
    prenom: "Charles",
    projet: "La Black Room, devenue L'Éclipse — Douai",
    texte: "Sans l'accompagnement, je n'aurais jamais acheté cet appartement. Élise est incroyable, toujours disponible, toujours là pour motiver quand les doutes s'installent.",
    resultat: "+ 2 600 € de cash-flow net par mois — 80 % de taux d'occupation",
    photo: "/clients/charles.jpg",
    video: null,
    link: { label: "Lire l'étude de cas complète", to: "/etude-de-cas/eclipse" },
  },
  {
    prenom: "Jérémy",
    projet: "Jérémy Négrier — investisseur immobilier, membre de l'équipe",
    texte: "J'ai exploré et testé les diverses stratégies d'investissement. J'ai découvert les logements atypiques avec des investisseurs comme Élise. Je baigne dans l'immobilier depuis que j'ai 20 ans.",
    resultat: null,
    photo: null,
    video: null,
  },
];

// Captures réelles d'annonces & avis voyageurs (issus du webinaire).
export const AVIS_CAPTURES = [
  { image: "/clients/avis-caliente.jpg", alt: "Avis Airbnb de La Caliente — 4,94/5 avec 494 commentaires" },
  { image: "/clients/avis-charmeuse.jpg", alt: "Avis Airbnb de La Charmeuse — 4,84/5 avec 150 commentaires" },
  { image: "/clients/avis-3.jpg", alt: "Avis voyageurs sur La Cachette — 4,95/5" },
];

export const STORY = {
  eyebrow: "Notre histoire",
  title: "L'histoire d'Élise, fondatrice.",
  blocks: [
    "J'étais assistante maternelle. 18 ans de métier. J'aimais mon métier, mais je donnais énormément de temps pour très peu de liberté en retour. Je me disais : il faut que je trouve autre chose.",
    "2021, le déclencheur : un voyage aux États-Unis où je découvre ces logements différents. Avec mon mari Laurent, on s'est dit : pourquoi on n'aurait pas ça chez nous ?",
    "Mon premier projet ? Mon garage, dans mon jardin : 3 240 € de revenus locatifs par mois dès les premiers mois. Puis La Charmeuse (2 872 €/mois), puis La Cachette, puis un troisième bien géré en sous-location sur le thème du Mexique.",
    "Depuis, j'ai accompagné des centaines de personnes à faire pareil — des couples, des personnes seules, des salariés, des fonctionnaires, des entrepreneurs. Certaines partaient de zéro. Toutes avaient un point commun : l'envie de sortir des modèles classiques.",
  ],
};

// ---------- WEBINAIRE ----------
export const WEBINAR = {
  enabled: true,
  eyebrow: "Webinaire gratuit",
  title: "Comment générer minimum un SMIC dans ta poche chaque mois, avec 1 seul bien immobilier.",
  subtitle: "La stratégie qui a changé ma vie et qui peut changer la tienne.",
  tagline: "Accessible · Petit budget · La liberté financière à portée de main",
  visual: "/brand/logo.jpg",
  note: "Prochaine session : date à venir. Inscris-toi pour réserver ta place et être prévenu(e) en premier.",
  cta: "JE RÉSERVE MA PLACE",
  // Connexion Systeme.io : le backend transmet les inscriptions à
  // SYSTEMEIO_WEBHOOK_URL dès que cette variable est configurée.
};

// ---------- PAGE RENDEZ-VOUS ----------
export const BOOKING = {
  title: "Parlons de votre projet.",
  intro:
    "Vous avez déjà un projet ? Vous recherchez encore votre bien ? Vous souhaitez créer une suite romantique, un hébergement familial à thème, un lieu de séminaire ou tout autre concept immobilier différent ?",
  intro2: "Réservez un échange avec notre équipe pour nous présenter votre projet.",
  cta: "JE PRENDS RENDEZ-VOUS",
  // Intégration d'un calendrier externe (Calendly, Cal.com...) :
  // collez ici l'URL d'intégration pour l'afficher dans la page.
  externalCalendarUrl: null,
  questions: {
    has_property: {
      label: "Avez-vous déjà un bien ?",
      options: ["Oui, déjà propriétaire", "Non, je suis en recherche", "Pas encore, je m'informe"],
    },
    project_type: {
      label: "Quel type de projet souhaitez-vous réaliser ?",
      options: ["Suite romantique / Love Room", "Hébergement familial à thème", "Logement gaming, cinéma ou séries", "Refuge nature déconnecté", "Lieu de séminaire work & fun", "Location courte durée", "Je ne sais pas encore"],
    },
    zone: { label: "Dans quelle zone géographique ?", placeholder: "Ex. : région, ville ou département visé" },
    stage: {
      label: "Où en êtes-vous dans votre projet ?",
      options: ["Je m'informe", "Je débute ma réflexion", "Je recherche activement un bien", "J'ai déjà trouvé un bien", "Mon projet est en cours"],
    },
    objective: {
      label: "Quel est votre objectif ?",
      options: ["Revenus complémentaires", "Investissement locatif structuré", "Créer une activité", "Autre"],
    },
  },
};

// ---------- PAGE FORMATION / PROGRAMME (contenu du webinaire) ----------
export const PROGRAM = {
  eyebrow: "Formation & accompagnement",
  title: "De la stratégie au lancement, à chaque étape, quelqu'un est là.",
  intro: "Notre programme suit exactement la méthode que nous appliquons sur nos propres logements et sur ceux de nos clients. Dix étapes, dans l'ordre, avec l'expertise de l'équipe à chaque moment clé. Aucun tarif n'est publié : les modalités sont définies après un premier échange.",
  forWho: [
    "Vous n'avez jamais investi et vous voulez éviter les erreurs coûteuses du premier projet.",
    "Vous êtes salarié(e), fonctionnaire, indépendant(e) ou déjà propriétaire : nos clients viennent de tous les profils.",
    "Vous voulez un projet qui a une identité, pas un énième appartement « meubles suédois » comparé au prix.",
    "Vous ne voulez plus avancer seul(e) : stratégie, technique, architecture, financement, exploitation.",
  ],
  steps: [
    { n: "01", title: "On analyse ta situation et on définit ta stratégie", lead: "On ne cherche pas un bien. On définit d'abord ce qui va fonctionner pour toi.", points: ["Quel budget réel ? Ta capacité d'emprunt calculée précisément, pas estimée.", "Quel concept ? On commence à réfléchir à un univers qui t'attire, défini ensuite selon ton secteur et ton bien.", "Bilan personnalisé : revenus, charges, épargne, endettement, objectif. Rien n'est supposé."], with: "Élise" },
    { n: "02", title: "On valide ton secteur et on part chercher le bon bien", lead: "On cherche ton bien — celui qui fait les chiffres.", points: ["Validation du secteur : prix au m², concurrence, axes routiers, accessibilité.", "Sourcing off-market : annonces, agences locales, marchands de biens, particuliers.", "Préparation des visites : checklist, bonnes questions, points qui font baisser le prix."], with: "Élise" },
    { n: "03", title: "Le bien est validé techniquement avant que tu signes", lead: "On chiffre et on valide avant tout engagement. Pas d'improvisation.", points: ["Analyse photos & vidéos à distance de chaque pièce.", "Contraintes techniques identifiées : amiante, plomb, humidité, structure, toiture, électricité, plomberie.", "Estimation précise des travaux pour se positionner vite et construire la rentabilité sur du solide."], with: "Élise & Laurent — 20 ans dans le bâtiment" },
    { n: "04", title: "On crée ensemble l'univers qui va faire réserver", lead: "Ce n'est pas de la décoration. C'est une identité.", points: ["Définition du thème à partir de ton bien, de ta cible et du marché local.", "Plans 2D/3D et visite virtuelle : tu vois ton logement terminé.", "Shopping list clés en main : fournisseurs partenaires, produits sélectionnés et testés."], with: "Élise & Laurie — architecte d'intérieur spécialisée atypique" },
    { n: "05", title: "Tu négocies et tu sécurises le compromis", lead: "La marge se fait à l'achat.", points: ["Rédaction de l'offre d'achat qui protège tes intérêts.", "Stratégie de négociation : prix plancher, arguments, conditions suspensives.", "Lecture du compromis : chaque clause relue avant de signer."], with: "Élise" },
    { n: "06", title: "On prépare ton dossier et on va chercher le financement", lead: "Un dossier bien présenté, c'est la différence entre un oui rapide et des mois de galère.", points: ["Dossier bancaire préparé avec méthode : projet locatif, projections chiffrées, argumentaire.", "Démarchage et coaching bancaire : plusieurs établissements consultés, on prend le meilleur.", "Les conditions qu'on va chercher : la durée la plus longue possible et le différé d'emprunt pendant les travaux."], with: "Élise" },
    { n: "07", title: "On choisit la structure juridique adaptée", lead: "Le bon choix peut t'économiser des milliers d'euros sur 10 ans.", points: ["Nom propre (LMNP), SARL de famille, SAS/SASU, LMP, SCI : les options selon ton profil et tes objectifs.", "Intervention de Jérémy Négrier, investisseur immobilier, sur les structures adaptées à l'atypique.", "Expert-comptable partenaire : la structure est choisie avant l'acte authentique."], with: "Élise & Jérémy" },
    { n: "08", title: "Les travaux démarrent — le chantier est piloté", lead: "Tout est planifié en amont. Sur le terrain, on est là à chaque étape.", points: ["Planification avant même la signature : chaque poste défini, chaque délai anticipé.", "Suivi de chantier continu : dérives détectées avant qu'elles impactent budget ou délais.", "Checklists d'ouverture : consommables, linge, équipements, accueil voyageur, photos."], with: "Élise, Laurie & Laurent" },
    { n: "09", title: "Tu lances, les réservations rentrent", lead: "Ton logement cartonne et tu restes tranquille.", points: ["Annonces optimisées : titre, description, photos professionnelles.", "Stratégie tarifaire selon la saison, les événements locaux, la concurrence.", "Mise en ligne calibrée : Airbnb, Booking, réservations directes, messages automatiques."], with: "Anaïs — conciergerie spécialisée atypique" },
    { n: "10", title: "Ton logement devient une vraie marque", lead: "Un logement anonyme se remplit. Une marque se réserve des mois à l'avance.", points: ["Logo & identité visuelle : ton logement n'est plus « un Airbnb », c'est une destination.", "Page Instagram du logement : les voyageurs te découvrent avant Airbnb et réservent en direct.", "Expérience voyageur : livret d'accueil, signalétique, détails qui génèrent les 5 étoiles."], with: "Élise & notre partenaire image de marque" },
  ],
  faq: [
    { q: "Faut-il un apport ?", a: "Non, l'apport n'est pas obligatoire : aucun texte de loi ne l'impose, c'est une décision de la banque. Ce qui la rassure : une bonne tenue de compte, une épargne régulière, un dossier carré. Et ça, ça s'apprend." },
    { q: "Comment la banque voit-elle un logement atypique ?", a: "On le présente comme un investissement locatif classique, modèle qu'elle maîtrise. Un dossier solide avec étude de marché et projections réalistes : c'est ainsi que nos clients obtiennent leurs prêts, même avec un endettement déjà entamé." },
    { q: "Pourquoi le différé d'emprunt change tout ?", a: "Pendant les travaux (3 à 6 mois), tu ne rembourses pas encore le capital. Tu ouvres, tu encaisses, puis le crédit démarre quand le logement tourne déjà. On le demande systématiquement." },
    { q: "Quel budget pour un projet atypique ?", a: "Un projet atypique coûte rarement plus de 150 000 €. Tu peux aller plus loin si tu le souhaites, mais tu n'as pas à le faire." },
  ],
  bilan: { eyebrow: "Bilan de ton projet — offert", title: "45 minutes avec notre équipe.", points: ["On fait le point sur ta situation : budget, profil, région.", "On évalue ensemble la faisabilité de ton projet (si tu n'en as pas encore, ce n'est pas grave).", "On t'explique comment on travaille et si c'est fait pour toi."], cta: "Réserver mon bilan offert" },
};

// ---------- PAGES LÉGALES ----------
export const LEGAL_CONTACT_EMAIL = "demoiselleatypique@gmail.com";

export const LEGAL_PAGES = {
  "mentions-legales": {
    title: "Mentions légales",
    intro: "Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, les informations suivantes sont portées à la connaissance des utilisateurs du site.",
    blocks: [
      { h: "Éditeur du site", p: ["SAS DEMOISELLE ATYPIQUE — Société par actions simplifiée au capital social de 5 000 €.", "Siège social : 82 allée des Tuileries, 33380 Biganos, France.", "SIREN : 982 143 695 — TVA intracommunautaire : FR31 982143695.", `E-mail : ${LEGAL_CONTACT_EMAIL}`] },
      { h: "Direction de la publication", p: ["Élise Chauvet, en qualité de présidente de la SAS DEMOISELLE ATYPIQUE."] },
      { h: "Hébergement", p: ["Informations hébergeur à compléter : dénomination sociale, adresse du siège et numéro de téléphone de l'hébergeur du site."] },
      { h: "Propriété intellectuelle", p: ["L'ensemble des éléments composant le site (textes, photographies, visuels, logo, identité graphique, vidéos, structure et mise en page) est protégé par le droit d'auteur et le droit des marques et demeure la propriété exclusive de la SAS DEMOISELLE ATYPIQUE ou de ses partenaires.", "Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie de ces éléments, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de la SAS DEMOISELLE ATYPIQUE.", "Les photographies de logements appartenant à des clients sont publiées avec leur accord."] },
      { h: "Limitation de responsabilité", p: ["Les informations diffusées sur le site sont fournies à titre indicatif. La SAS DEMOISELLE ATYPIQUE s'efforce d'en assurer l'exactitude et la mise à jour, sans pouvoir garantir l'absence d'erreurs ou d'omissions.", "Les chiffres, résultats et témoignages présentés correspondent à des projets réels, communiqués par leurs propriétaires ; ils ne constituent ni une garantie de résultat ni un conseil en investissement. Tout projet immobilier comporte des risques et doit faire l'objet d'une analyse personnalisée.", "La SAS DEMOISELLE ATYPIQUE ne saurait être tenue responsable des dommages directs ou indirects résultant de l'accès au site, de son utilisation ou de l'impossibilité d'y accéder, ni du contenu des sites tiers vers lesquels des liens peuvent renvoyer."] },
      { h: "Données personnelles & cookies", p: ["Les modalités de traitement des données personnelles et l'usage des cookies sont détaillés dans la Politique de confidentialité et la Politique de cookies accessibles depuis le pied de page."] },
      { h: "Droit applicable", p: ["Le site et ses mentions légales sont soumis au droit français. En cas de litige et à défaut de résolution amiable, les tribunaux français seront seuls compétents."] },
    ],
  },
  "politique-de-confidentialite": {
    title: "Politique de confidentialité",
    intro: "La SAS DEMOISELLE ATYPIQUE attache une grande importance à la protection de vos données personnelles. La présente politique décrit, conformément au Règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés, les traitements réalisés via le site.",
    blocks: [
      { h: "Responsable du traitement", p: [`SAS DEMOISELLE ATYPIQUE — 82 allée des Tuileries, 33380 Biganos, France — ${LEGAL_CONTACT_EMAIL}.`] },
      { h: "Données collectées", p: ["Formulaire d'inscription au webinaire : prénom, nom, adresse e-mail, numéro de téléphone.", "Formulaire de prise de rendez-vous : prénom, nom, adresse e-mail, numéro de téléphone, ainsi que les informations de qualification de votre projet (situation vis-à-vis d'un bien, type de projet, zone géographique, étape d'avancement, objectif, message libre et, le cas échéant, les chiffres saisis dans le simulateur).", "Aucune donnée n'est collectée à votre insu : seules les informations que vous renseignez volontairement dans ces formulaires sont enregistrées."] },
      { h: "Finalités et bases légales", p: ["Traiter votre inscription au webinaire et vous adresser les informations pratiques relatives à celui-ci (exécution de votre demande).", "Traiter votre demande de rendez-vous, vous recontacter et préparer l'échange sur votre projet (exécution de votre demande et intérêt légitime à répondre aux sollicitations).", "Vous adresser, si vous y avez consenti, des communications sur nos accompagnements et événements (consentement, que vous pouvez retirer à tout moment)."] },
      { h: "Destinataires", p: ["Les données sont destinées à l'équipe de la SAS DEMOISELLE ATYPIQUE. Elles sont hébergées dans la base de données du site. Elles ne sont ni vendues ni cédées à des tiers.", "Le site charge des polices de caractères depuis Google Fonts : lors de l'affichage des pages, votre navigateur transmet votre adresse IP aux serveurs de Google. Aucun autre service tiers de mesure d'audience, de publicité ou de réseau social n'est intégré au site à ce jour."] },
      { h: "Durée de conservation", p: ["Les données de prospects (inscriptions au webinaire, demandes de rendez-vous) sont conservées au maximum 3 ans à compter du dernier contact de votre part, puis supprimées.", "Lorsqu'une relation contractuelle s'établit, les données sont conservées pendant la durée de la relation puis archivées selon les durées légales applicables."] },
      { h: "Vos droits", p: ["Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation du traitement et de portabilité de vos données. Lorsqu'un traitement repose sur votre consentement, vous pouvez le retirer à tout moment, sans que cela remette en cause la licéité du traitement effectué avant ce retrait.", `Pour exercer ces droits, écrivez-nous à ${LEGAL_CONTACT_EMAIL} en précisant votre demande. Une réponse vous sera apportée dans un délai d'un mois.`, "Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr) si vous estimez que vos droits ne sont pas respectés."] },
      { h: "Sécurité", p: ["Nous mettons en œuvre des mesures techniques et organisationnelles raisonnables pour protéger vos données contre la perte, l'accès non autorisé ou la divulgation."] },
      { h: "Cookies", p: ["Le site ne dépose actuellement aucun cookie de mesure d'audience, publicitaire ou de réseau social. Le détail figure dans la Politique de cookies."] },
      { h: "Mise à jour", p: ["La présente politique peut être mise à jour pour refléter l'évolution du site ou de la réglementation. La version en ligne fait foi."] },
    ],
  },
  cgv: {
    title: "CGV — Conditions générales",
    intro: "Les présentes conditions encadrent l'utilisation du site et l'accès aux accompagnements proposés par la SAS DEMOISELLE ATYPIQUE.",
    blocks: [
      { h: "Objet", p: ["Les présentes conditions régissent l'utilisation du site et la présentation des formations et accompagnements proposés par la SAS DEMOISELLE ATYPIQUE."] },
      { h: "Accompagnements & formation", p: ["Les modalités et conditions financières de chaque accompagnement ou formation sont définies sur mesure, après un premier échange, dans un document contractuel dédié remis au client. Aucun tarif n'est publié sur ce site."] },
      { h: "Responsabilité", p: ["Chaque projet immobilier comporte des risques propres. Les informations diffusées ne constituent ni un conseil en investissement ni une garantie de résultat."] },
      { h: "Droit applicable", p: ["Droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire."] },
    ],
  },
  "politique-de-cookies": {
    title: "Politique de cookies",
    intro: "Un cookie est un petit fichier déposé sur votre terminal lors de la consultation d'un site. Cette page décrit de façon transparente l'usage qui en est fait sur ce site.",
    blocks: [
      { h: "Cookies utilisés", p: ["À ce jour, le site ne dépose aucun cookie de mesure d'audience, de publicité, de personnalisation ou de réseau social, et n'utilise aucun traceur nécessitant votre consentement.", "Seuls des éléments techniques strictement nécessaires au fonctionnement du site (affichage des pages, envoi des formulaires) peuvent être utilisés par votre navigateur ; ils ne servent pas à vous suivre."] },
      { h: "Bandeau de consentement", p: ["Aucun cookie soumis à consentement n'étant déposé, aucun bandeau de gestion des cookies n'est nécessaire. Si des outils de mesure d'audience ou de communication étaient ajoutés à l'avenir, un bandeau conforme permettant d'accepter ou de refuser aussi simplement ces cookies serait mis en place et la présente page mise à jour."] },
      { h: "Ressources tierces", p: ["Les polices de caractères du site sont chargées depuis Google Fonts. Cette ressource technique implique la transmission de votre adresse IP à Google lors du chargement des pages, sans dépôt de cookie par nos soins."] },
      { h: "Paramétrer votre navigateur", p: ["Vous pouvez à tout moment configurer votre navigateur pour bloquer ou supprimer les cookies. Le fonctionnement du site n'en sera pas affecté."] },
      { h: "Contact", p: [`Pour toute question : ${LEGAL_CONTACT_EMAIL}.`] },
    ],
  },
};
